export const media = {
  hero: {
    avif: "/manus-storage/hero-1920_7b8d126b.avif",
    webp: "/manus-storage/hero-1920_0585c996.webp",
    srcSet: "/manus-storage/hero-320_743b82e0.webp 320w, /manus-storage/hero-640_7374b40d.webp 640w, /manus-storage/hero-960_0653ff90.webp 960w, /manus-storage/hero-1280_481f3530.webp 1280w, /manus-storage/hero-1920_0585c996.webp 1920w",
    width: 1920,
    height: 1072,
  },
  approach: {
    avif: "/manus-storage/approach-texture-1434_aedde786.avif",
    webp: "/manus-storage/approach-texture-1434_b2bbb7dd.webp",
    srcSet: "/manus-storage/approach-texture-320_29ee974b.webp 320w, /manus-storage/approach-texture-640_d7c8ff30.webp 640w, /manus-storage/approach-texture-960_444807ce.webp 960w, /manus-storage/approach-texture-1280_72f7e31f.webp 1280w, /manus-storage/approach-texture-1434_b2bbb7dd.webp 1434w",
    width: 1434,
    height: 1920,
  },
  abstract: {
    avif: "/manus-storage/abstract-pattern-1920_12f7b53a.avif",
    webp: "/manus-storage/abstract-pattern-1920_ff27d703.webp",
    srcSet: "/manus-storage/abstract-pattern-320_4197b247.webp 320w, /manus-storage/abstract-pattern-640_f3713ab8.webp 640w, /manus-storage/abstract-pattern-960_cd941d1f.webp 960w, /manus-storage/abstract-pattern-1280_93f270bc.webp 1280w, /manus-storage/abstract-pattern-1920_ff27d703.webp 1920w",
    width: 1920,
    height: 1072,
  },
  portfolio: {
    avif: "/manus-storage/portfolio-1920_4f4817e1.avif",
    webp: "/manus-storage/portfolio-1920_80603405.webp",
    srcSet: "/manus-storage/portfolio-320_a27f1931.webp 320w, /manus-storage/portfolio-640_f15ebef0.webp 640w, /manus-storage/portfolio-960_e889a7b0.webp 960w, /manus-storage/portfolio-1280_32733c86.webp 1280w, /manus-storage/portfolio-1920_80603405.webp 1920w",
    width: 1920,
    height: 1288,
  },
  team: {
    avif: "/manus-storage/team-bg-1920_953d2545.avif",
    webp: "/manus-storage/team-bg-1920_7c112282.webp",
    srcSet: "/manus-storage/team-bg-320_19f3b982.webp 320w, /manus-storage/team-bg-640_df65dedd.webp 640w, /manus-storage/team-bg-960_2678a0b4.webp 960w, /manus-storage/team-bg-1280_eeb82878.webp 1280w, /manus-storage/team-bg-1920_7c112282.webp 1920w",
    width: 1920,
    height: 1072,
  },
  ryan: {
    avif: "/manus-storage/ryan-400_f4ebc0f8.avif",
    webp: "/manus-storage/ryan-400_ece2456e.webp",
    srcSet: "/manus-storage/ryan-320_280c96eb.webp 320w, /manus-storage/ryan-400_ece2456e.webp 400w",
    width: 400,
    height: 400,
  },
} as const;
